import OrderDiscounts from './OrderDiscounts'

export * from './OrderDiscounts'

export default OrderDiscounts
